import React, { useRef } from 'react'
import styled, { keyframes } from 'styled-components'
import Button from './Button';
import { useTranslation } from 'react-i18next';

import img1 from '../../assets/Nfts/1.jpg';
import img2 from '../../assets/Nfts/2.jpg';
import img3 from '../../assets/Nfts/3.jpg';
import img4 from '../../assets/Nfts/4.jpg';
import img5 from '../../assets/Nfts/5.jpg';
import img6 from '../../assets/Nfts/6.jpg';
import img7 from '../../assets/Nfts/7.jpg';
import img8 from '../../assets/Nfts/8.jpg';
import img9 from '../../assets/Nfts/9.jpg';
import img10 from '../../assets/Nfts/10.jpg';
import ETH from '../../assets/icons8-ethereum-48.png'

const Section = styled.section`
min-height: 100vh;
width: 100vw;
background-color: ${props => props.theme.text};
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
position: relative;
overflow: hidden;

&>*:first-child{
  animation-duration: 20s;

  @media (max-width: 30em){
    animation-duration: 15s;

  }
}
&>*:last-child{
  animation-duration: 15s;
  @media (max-width: 30em){
    animation-duration: 10s;

  }
}
`

const Title = styled.h1`
  font-size: ${(props) => props.theme.fontxxl};
  text-transform: uppercase;
  color: ${(props) => props.theme.body};
  
  margin: 1rem auto;
  border-bottom: 2px solid ${(props) => props.theme.carouselColor};
  width: fit-content;

  @media (max-width: 48em){
  font-size: ${(props) => props.theme.fontxl};

  }
`;


const move = keyframes`
0%{ transform: translateX(100%)   };
100%{ transform: translateX(-100%)   }

`
const ButtonContainer = styled.div`
font-size: ${(props) => props.theme.fontxl};
  text-transform: uppercase;
 margin: 1rem auto;
 width: fit-content;
display: inline-block;
background-color: ${props => props.theme.body};
color: ${props => props.theme.text};
outline: none;
border: none;
font-weight: 600;
padding: 0.5rem 0.5rem;
border-radius: 50px;
cursor: pointer;
transition: all 0.2s ease;
position: relative;

 display: flex;
  align-self: flex-start;

  @media (max-width: 64em){
    align-self: center;
    text-align:center;

    button{
      margin: 0 auto;
    }
}

`


const Row = styled.div`
/* background-color: lightblue; */
white-space: nowrap;
box-sizing:content-box;
margin: 6rem 0;
display: flex;

animation: ${move}  linear infinite ${props => props.direction};


`
const ImgContainer = styled.div`
width: auto;
margin: 0 1rem;
background-color:${props => props.theme.body};

border-radius: 20px;
cursor: pointer;

@media (max-width: 48em){
  width: 12rem;
  }
  @media (max-width: 30em){
  width: 10rem;
  }

img{
  width: 100%;
  height: 100%; //auto 
}
`

const Details = styled.div`
display: flex;
justify-content: space-between;
padding: 0.8rem 1rem;
background-color: ${props => props.theme.text};
border: 2px solid ${props => `rgba(${props.theme.bodyRgba},0.5)`};

border-bottom-left-radius: 20px;
border-bottom-right-radius: 20px;

span{
  font-size: ${props => props.theme.fontsm};
  color:${props => `rgba(${props.theme.bodyRgba},0.5)`};
  font-weight:600;
  line-height: 1.5rem;
}

h1{
  font-size: ${props => props.theme.fontmd};
  color: ${props => props.theme.body};
  font-weight:600;

  @media (max-width: 30em){
    font-size: ${props => props.theme.fontsm};

  }

}

`

const Price = styled.div`
display: flex;
justify-content: flex-start;
align-items: center;

img{
  width: 1rem;
  height: auto;

}
`

const NftItem = ({img, name, number=0, price=0, passRef}) => {

let play = (e) => {
  passRef.current.style.animationPlayState = 'running';
}
let pause = (e) => {
  passRef.current.style.animationPlayState = 'paused';
}

const { t, i18n } = useTranslation();
  return(
    <ImgContainer   onMouseOver={e => pause(e) }  onMouseOut={e => play(e) }  >
      <img width={500} height={400}  src={img} alt="NOIR ARTIST" />
      <Details>
      <div>
          <span>{t('SectionShowcasejs.1')}</span> <br />
          <h1>{name}</h1>
        </div>
        <div>
          <span>{t('SectionShowcasejs.2')}</span> <br />
          <h1>#{number}</h1>
        </div>

        <div>
          <span>{t('SectionShowcasejs.3')}</span>
          <Price>
          <img width={200} height={200}  src={ETH} alt="ETH" />
          <h1>{Number(price).toFixed(2)}</h1>
          </Price>
        </div>
      </Details>
    </ImgContainer>
  )
} 


const Showcase = () => {

  const Row1Ref = useRef(null);
  const Row2Ref = useRef(null);
  const Row3Ref = useRef(null);
  const { t, i18n } = useTranslation();
  return(
    <Section id="showcase">
    <Row direction="none" ref={Row1Ref}>
    <a href="https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/96302447215318584732158045189014489076994714479245352151991080618922193453057" target="_blank"  rel="noopener noreferrer">
      <NftItem img={img1}  name="AMOR" number={7} price={0.15}   passRef = {Row1Ref} onclick="https://opensea.io/collection/noirartist" />
      </a>
      <a href="https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/96302447215318584732158045189014489076994714479245352151991080577140751597569" target="_blank"  rel="noopener noreferrer">
      <NftItem img={img2}  name="1984" number={5} price={0.15}   passRef = {Row1Ref} />
            </a>


      <a href="https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/96302447215318584732158045189014489076994714479245352151991080611225612058625" target="_blank"  rel="noopener noreferrer">
      <NftItem img={img3}  name="Power" number={7} price={0.15}   passRef = {Row1Ref} />
            </a>


      <a href="https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/96302447215318584732158045189014489076994714479245352151991080591434402758657" target="_blank"  rel="noopener noreferrer">
      <NftItem img={img4}  name="AARGH" number={3} price={0.15}   passRef = {Row1Ref} />
            </a>


      <a href="https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/96302447215318584732158045189014489076994714479245352151991080598031472525313" target="_blank"  rel="noopener noreferrer">
      <NftItem img={img5}  name="Snake face" number={2} price={0.15}   passRef = {Row1Ref} />
            </a>


    </Row>
    <ButtonContainer>
    <Button text={t('SectionShowcasejs.4')} link="https://opensea.io/collection/noirartist" />
    </ButtonContainer>

    <Row direction="reverse" ref={Row3Ref}>
    <a href="https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/96302447215318584732158045189014489076994714479245352151991080587036356247553" target="_blank"  rel="noopener noreferrer">
    <NftItem img={img6}  name="Mad society" number={7} price={0.15}   passRef = {Row3Ref} />
    </a>

    <a href="https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/96302447215318584732158045189014489076994714479245352151991080538657844625409" target="_blank"  rel="noopener noreferrer">
    <NftItem img={img7}  name="Let it Go" number={5} price={0.15}   passRef = {Row3Ref} />
    </a>

    <a href="https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/96302447215318584732158045189014489076994714479245352151991080554051007414273" target="_blank"  rel="noopener noreferrer">
    <NftItem img={img8}  name="Kintsugi brain" number={5} price={0.15}   passRef = {Row3Ref} />
    </a>

    <a href="https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/96302447215318584732158045189014489076994714479245352151991080622220728336385" target="_blank"  rel="noopener noreferrer">
    <NftItem img={img9}  name="KABOOM" number={3} price={0.15}   passRef = {Row3Ref} />
    </a>

    <a href="https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/96302447215318584732158045189014489076994714479245352151991080569444170203137" target="_blank"  rel="noopener noreferrer">
    <NftItem img={img10}  name="Heart" number={5} price={0.15}   passRef = {Row3Ref} />
    </a>

    </Row>
    </Section>
  )
}

export default Showcase